var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24SearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54167 0.5C3.21235 0.5 0.5 3.21235 0.5 6.54167C0.5 9.87098 3.21235 12.5833 6.54167 12.5833C7.98182 12.5833 9.30571 12.0746 10.3454 11.2292L14.4331 15.3169C14.4907 15.3769 14.5597 15.4248 14.636 15.4578C14.7123 15.4907 14.7945 15.5082 14.8776 15.509C14.9608 15.5099 15.0433 15.4941 15.1202 15.4627C15.1972 15.4312 15.2672 15.3848 15.326 15.326C15.3848 15.2672 15.4312 15.1972 15.4627 15.1202C15.4941 15.0433 15.5099 14.9608 15.509 14.8776C15.5082 14.7945 15.4907 14.7123 15.4578 14.636C15.4248 14.5597 15.3769 14.4907 15.3169 14.4331L11.2292 10.3454C12.0746 9.30571 12.5833 7.98182 12.5833 6.54167C12.5833 3.21235 9.87099 0.5 6.54167 0.5ZM6.54167 1.75C9.19544 1.75 11.3333 3.8879 11.3333 6.54167C11.3333 7.83442 10.8234 9.00238 9.99626 9.86279C9.94527 9.90027 9.90027 9.94527 9.86279 9.99626C9.00238 10.8234 7.83442 11.3333 6.54167 11.3333C3.8879 11.3333 1.75 9.19543 1.75 6.54167C1.75 3.8879 3.8879 1.75 6.54167 1.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24SearchBlack);
export default __webpack_public_path__ + "static/media/icn_24x24_search_black.95df352a95591f78ceb844bddf274903.svg";
export { ForwardRef as ReactComponent };